export default __webpack_public_path__ + "static/media/chart_of_accounts_template.9cc4b723.xlsx";